module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact fk__contact"
  }, [_c('div', {
    staticClass: "fk__contact__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__contact__box"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--light fk__contact__heading"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('p', {
    staticClass: "fk__contact__box__copy"
  }, [_vm._v("\n      Famous King Inc."), _c('br'), _vm._v("\n      P.O. Box 4682"), _c('br'), _vm._v("\n      Olathe, KS 66063\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "fk__contact__social"
  }, [_c('li', {
    staticClass: "fk__contact__social__icon"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/famouskingmedia"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/social/facebook.svg")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fk__contact__social__icon"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/famouskingmedia"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/social/instagram.svg")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fk__contact__social__icon"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/famouskingmedia"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/social/twitter.svg")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__contact__box fk__contact__box--white"
  }, [_c('form', {
    staticClass: "fk__contact__form",
    attrs: {
      "id": "ajax-contact",
      "method": "post",
      "action": "http://famousking.com/email.php"
    }
  }, [_c('input', {
    staticClass: "fk__contact__form__input",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text",
      "autocomplete": "off",
      "required": "",
      "placeholder": "Name / Organization"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fk__contact__form__input",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "autocomplete": "off",
      "required": "",
      "placeholder": "Email Address"
    }
  }), _vm._v(" "), _c('textarea', {
    staticClass: "fk__contact__form__textarea",
    attrs: {
      "id": "message",
      "name": "message",
      "autocomplete": "off",
      "required": "",
      "placeholder": "Type your message here..."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "fk__contact__form__button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send Email")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "form-messages"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43cefbc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 77
// module chunks = 0